import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/z-score-calculator',
  component: () => import('../../routes/ZScoreCalculator.svelte'),
  card: {
    id: 'z-score-calculator',
    title: 'Z-Score Calculator',
    description:
      'Calculate how many standard deviations a value is from the mean. Find percentile rankings and probability under the normal curve.',
    icon: 'analytics',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/z-score-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Z-Score Calculator – Standard Score & Percentile Finder',
    description:
      'Free z-score calculator. Convert any raw value to a standard score (z-score) to find how many standard deviations it is from the mean and its percentile rank.',
  },
};

export default meta;